import { Component } from '@angular/core';
import { ControlTablesService } from 'src/app/assabil-kernel/services/control-tables-service';
import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { PaymentTerm } from 'src/app/assabil-kernel/models/entities/control-tables/payment-term';
import { GenericLovComponent } from 'src/app/tools/abstract-classes/generic-lov.component';
import { MatDialogRef } from '@angular/material/dialog';


@Component({
  selector: 'payment-term-lov',
  templateUrl: './payment-term-lov.component.html',
  styleUrls: ['./payment-term-lov.component.scss']
})


export class PaymentTermLovComponent extends GenericLovComponent   {

   code         : string; 
   name         : string; 

    paymentTerms: PaymentTerm[] = [];

    columns = [
        {  prop: 'paymentTermCode', name: 'Code'},
        {  prop: 'name',            name: 'Nom'}
    ]


//----------------------------------------------------------------------
constructor( 
    public dialogRef: MatDialogRef<PaymentTermLovComponent>,
    protected controlTablesService  : ControlTablesService) {
    super();
    this.entityName = "paymentTerm";
}
//----------------------------------------------------------------------
    


//----------------------------------------------------------------------
loadData() {
    let request: BaseRequest = new BaseRequest(this.controlTablesService.getUserInfo());
    request.strArg1 = this.code;
    request.strArg2 = this.name;

    this.controlTablesService.getList(this.entityName, request).then(result => {
        this.paymentTerms = result;
    })
}
//----------------------------------------------------------------------


//----------------------------------------------------------------------
closeModal(row : PaymentTerm){
    this.dialogRef.close(row);
}
//----------------------------------------------------------------------

}
